export default {
    user: {
        alert: {
            updated: "Account updated",
            created: "Account created"
        },
        removeAccount: {
            button: "Remove account",
            confirm: "Are you sure to remove your account ?"
        },
        register: {
            title: "Register",
            confirmation: {
                title: "Thank you for your registration",
                body: "An email has be sent to you to confirm the registration"
            },
            activation: {
                title: "The account has been activated",
                body: "You can now connect"
            }
        },
        dataExport: {
            link: "Download the data",
            fileName: "User data.json"
        },
        field: {
            email: "Email",
            password: "Password",
            passwordCheck: "Confirmation password",
            newPassword: "New password",
            alias: "Alias",
            maritalStatus: "Marital status",
            maritalStatusOptions: {
                singleMale: "Single Male",
                singleFemale: "Single Female",
                couple: "Couple"
            },
            maleBirthYear: "Male birth year",
            femaleBirthYear: "Female birth year",
            language: "Language",
            acceptNotifications: "Accept notifications",
            isAdult: "I certify on the honor be of legal age according to the law in force in my country of residence",
            tosAccept: "I have read the terms of service",
        },
        facebook: {
            loginButton: "Login with Facebook",
            createAccountMessage: "This will create an account linked to your Facebook account",
            createAccountButton: "Create account",
            editPermissionButton: "Edit Facebook Permissions"
        },
        auth: {
            login: 'Login',
            error: {
                login: 'Email ou mot de passe incorrect',
                expired: 'The session has expired'
            }
        }
    },
    question: {
        zeroPool: {
            error: "No more question available",
            message: "You can add questions from the ",
            previous: "Back to previous question"
        },
        form: {
            previous: "Previous",
            validate: "Validate",
            next: "Next (Skip the question)",
            fantasy: "Fantasy",
            action: "Action",
            gauge: "Excitation",
            complement: "Complement",
            errors: {
                answerRequired: "An answer should be selected",
                noQuestionAvailable: "No question available in English"
            },
            helptexts: {
                complement: "More information",
                question: "The question",
                answers: "Your answer",
                gaugeTitle: "Gauge",
                gauge: "Shows the excitation level inspired by the question",
                fantasyTitle: "Fantasm button",
                fantasy: "The topic is a fantasm for you",
                actionTitle: "Action button",
                action: "The question makes you want to do it",
            },
            bookmark : "Bookmark",
        },
        finished: {
            leadMessage: "Congratulations ! You have finished the questions !",
            unansweredMessage: "Howerever you have {0} unanswered questions remaining",
            unansweredLink: "See my unanswered questions",
            myAnswers: "See all my answers",
            allPacks: "See the other thematics",
            nextPack: "Next thematic",
        },
        skipConfirm: "Are you sure to continue ?\nYour modifications will be ignored."
    },
    userAnswers: {
        fields: {
            notion: "Notion",
            vision: "Vision",
            theme: "Theme",
            fantasy: "Fantasy",
            action: "Action",
            gauge: "Excitation",
            answerWeight: "Answer Weight",
            gaugeLevel: "Gauge Level",
            skipped: "No answer",
            bookmark: "Bookmark"
        },
        stats: {
            filters: "Filters",
            Q: "Q",
            A: "A",
            empty: "No answer",
            helptexts: {
                gaugeTitle: "Gauge filter",
                gauge: "Min/max cursors allows to filter the inclusive range of excitation gauge",
                actionTitle: "Action filter",
                action: "Shows only answers for which Action were selected",
                fantasyTitle: "Fantasme filter",
                fantasy: "Shows only answers for which Fantasm were selected",
                skippedTitle: "No answer filter",
                skipped: "Shows the questions without answer",
                bookmarkTitle: "Bookmark filter",
                bookmark: "Shows only bookmarked questions"
            }
        },
    },
    contacts: {
        description: "Your friends are listed bellow. You can see their answers by clicking on them",
        list: {
            add: "Add",
            refresh: "Reload",
            empty: "No friend found, give a token to a friend or add a friend's token using the Add button."
        },
        addModal: {
            title: "Add a friend",
            currentToken: "Single use token valid until {0}",
            getToken: "Generate token",
            contactToken: "Friend token",
            submitToken: "Add friend",
            scanQR: "Scan QR",
            getQR: "Generate QR",
            currentQR: "Single use QR valid until {0}",
            success: "Friend {0} added",
            emailAddress: "Friend request by email",
            emailAddressPlaceholder: "Friend's email",
            emailSubmit: "Send",
            emailSendSuccess: "The friend request has been sent",
            addTypes: {
              token: "Share token",
              scan: "Share QRCode",
              email: "Email invite",
            },
            error: {
                token: "Invalid friend token"
            }
        },
        addModalQR: {
            back: "Back",
            error: {
                cameraNotGranted: "Camera permission not granted",
                cameraNotFound: "Camera not found",
                cameraNotSupported: "Camera usage not supported",
                cameraInUse: "Camera already in use",
                unknown: "Error connecting to the camera "
            }
        },
        addURL: {
            confirmation: "Add friend with token {0} ?"
        },
        removeModal: {
            title: "Remove friend",
            message: "Do you want to remove {0} from your friend list ?"
        },
        show: {
            title: "Answers {0}",
            back: "Back",
            remove: "Remove",
        },
        error: {
            selfContact: "Current user can\'t be added as friend"
        }
    },
    offers: {
        success: "Purchase successful",
        list: {
            marketplace: "Marketplace",
            empty: "No thematic found",
            question: "question(s)",
            description: {
                text1: "For information, the number of questions proposed may vary depending on your answers. You currently have &hearts;&nbsp;<b>{questionPool}</b> questions, Your progress in the questionnaire allows you to answer at least &hearts;&nbsp;<b>{minRemainingQuestions}</b> questions in the near future.",
                text2: "Hence required amount of questions to finish is <b>&hearts;&nbsp;{missingPool}</b>.",
                text3: "Hence you have enough questions to finish."
            }
        },
        notPurchasable: "Offer not purchasable. Reason: The number of questions remaining is less than your question pool"
    },
    packs: {
        payment: {
            cancelled: "The transaction has been cancelled",
            transactionError: "Unexpected transaction data",
            success: "Payment successful"
        },
        list: {
            marketplace: "Marketplace",
            empty: "No thematic Found",
            play: "Play"
        },
        fields: {
            description: "Description",
        }
    },
    index: {
        discover: "Discover",
        title: "What's up",
        data: "Main Page"
    },
    about: {
        title: "About",
        data: "<p class=\"text-justify\">Bienvenue dans l’univers de <span class=\"font-weight-bold\">DeepLov.</span></p>"
        + "<p class=\"text-justify\">Notre but est simple, faire que votre <span class=\"font-weight-bold\">couple</span> reste à l’écoute de ses <span class=\"font-weight-bold\">envies</span> sexuelles.</p>"
        + "<p class=\"text-justify\">Pour stimuler son couple sur le plan <span class=\"font-weight-bold\">sexuel</span>, tout le monde s’accorderait à dire qu’il est nécessaire de partager ses <span class=\"font-weight-bold\">désirs</span>. Mais il existe de nombreux facteurs qui parfois bloquent cette possibilité. Livrer nos vraies envies s’avère souvent délicat.</p>"
        + "<p class=\"text-justify\">Aussi avons-nous créé DeepLov, dont la vocation est de vous aider à <span class=\"font-weight-bold\">explorer</span> et à révéler les différentes facettes de vos désirs et fantasmes sexuels.</p>"
        + "<p class=\"text-justify\">Nous avons pensé, avec justesse nous l’espérons, que la <span class=\"font-weight-bold\">femme</span> détenait de nombreuses clés pour <span class=\"font-weight-bold\">libérer</span> le potentiel sexuel au sein de son couple. C’est pourquoi, l’ensemble des questions s’adressent uniquement à elle.</p>"
        + "<p class=\"text-justify\">Articulé autour de nombreux thèmes de <span class=\"font-weight-bold\">sexualité</span>, des plus admis aux plus confidentiels, DeepLov vous invite à livrer vos propres désirs, attentes et <span class=\"font-weight-bold\">fantasmes</span> sexuels, mais aussi, à confier votre perception sur de nombreux sujets concernant votre <span class=\"font-weight-bold\">partenaire</span> masculin.</p>"
        + "<p class=\"text-justify\">Alors Messieurs, ne soyez pas frustrés, votre femme, amie, compagne, concubine, <span class=\"font-weight-bold\">amoureuse</span>, pourrait bien vous faire des <span class=\"font-weight-bold\">révélations</span>. Soyez heureux que cela se produise. Elle a des envies dont elle n’avait jamais parlé, prenez-le comme une preuve de grande <span class=\"font-weight-bold\">confiance</span>. Restez ouvert. Apportez des idées lorsqu’un thème l’intéresse. Votre partenaire va beaucoup vous donner, <span class=\"font-weight-bold\">accepter</span> de <span class=\"font-weight-bold\">recevoir</span> sans porter de jugement. Si vous n’aviez jamais osé lui révéler une de vos envies, alors qu’elle vous en parle positivement, n’hésitez pas à le lui dire.</p>"
        + "<p class=\"text-justify\">DeepLov peut se jouer en couple, mais il est également possible de laisser sa partenaire répondre seule puis de partager et d’échanger ensuite avec elle sur ses réponses.</p>"
        + "<p class=\"text-justify\">Il est temps de jouer maintenant !</p>"
    },
    help: {
        title: "Help",
        data: "<h4>Principe</h4>"
        + "<p class=\"text-justify\">Des centaines de questions vous sont proposées autour de nombreux thèmes. Toutes les réponses doivent être apportées uniquement par la femme au sein du couple.</p> <p>Nous vous conseillons de jouer à deux. Néanmoins une variante possible consiste à laisser la femme répondre seule aux questions pour ensuite livrer ses réponses à son partenaire.<p>"
        + "<h4 class=\"mt-4\">Comment répondre</h4>"
        + "<p class=\"text-justify\">À chaque question peut être associé un groupe de réponses, un bouton <span class=\"font-weight-bold\">Action</span>, un bouton <span class=\"font-weight-bold\">Fantasme</span>, une <span class=\"font-weight-bold\">Jauge</span> d’excitation.</p>"
        + "<p class=\"text-justify\">Si votre réponse n’est pas la bonne, recliquez dessus pour la désélectionner et en choisir une autre. Même principe avec les boutons et la jauge.</p>"
        + "<p class=\"text-justify\">Pour la jauge déplacez le curseur à votre convenance.</p>"
        + "<p class=\"text-justify\">Cliquez sur <span class=\"font-weight-bold\">Action</span> lorsque vous vous sentez prête à passer potentiellement à l’action concernant le sujet de la question. Cela ne revêt pas un caractère d’immédiateté (avis au partenaire).</p>"
        + "<p class=\"text-justify\">Cliquez sur <span class=\"font-weight-bold\">Fantasme</span> lorsque vous estimez qu’il serait possible de jouer avec le sujet de la question lors de vos ébats amoureux. Cela n’implique aucunement le désir de passer à l’acte.</p>"
        + "<p class=\"text-justify\">Utilisez la <span class=\"font-weight-bold\">jauge</span> d’excitation lorsqu’elle se présente pour simplement préciser, de façon plus ludique l’intérêt ou l’excitation que peut représenter le sujet de la question.</p>"
        + "<h4 class=\"mt-4\">Mes réponses</h4>"
        + "<p class=\"text-justify\">Retrouvez toutes vos réponses et utilisez les filtres pour voir ce qui vous intéresse.</p>"
    },
    contactForm: {
        subject: "Subject",
        message: "Message",
        from: "From",
        response: {
            success: "Message successfully sent"
        },
        subjects: {
            accountRemoval: "Account removal",
            functionalQuestion: "Functional question",
            technicalFeedback: "Technical feedback",
            suggestion: "Suggestion",
            other: "Other"
        },
    },
    passwordRecovery: {
        successSendEmail: "The recovery email has been sent",
        success: "The password has been reset successfully",
        title: "Forgotten password ?",
        placeholder: "Your registered email",
        error: {
            wrongEmail: "Wrong email",
            passwordsNoMatch: "Passwords not matching",
            invalidToken: "The recovery link has expired",
            emailNotExist: "Can't find that email",
        }
    },
    global: {
        catchPhrase: "High intimity game",
        error: {
            submission: "Submit Validation Failed",
            paypal: "Your registered email"
        },
        loading: "Loading",
        form: {
            submit: "Submit",
        },
        menu: {
            title: "DeepLOV",
            about: "About",
            help: "Help",
            questions: {
                label: "Questions",
                continue: "Play",
                packs: "Thematics",
                myAnswers: "My answers",
                myAnswersResponsive: "Answers",
                question: "question(s)"
            },
            marketplace: "More questions",
            marketplaceResponsive: "More",
            login: "Sign in",
            logout: "Logout",
            register: "Register",
            settings: "Settings",
            contacts: "Friends",
            questionPool: "Number of available questions",
            contactForm: "Contact us",
            tos: "CGU & CGV"
        },
        message: {
            giveAway: "20 questions unlocked"
        },
        modal: {
            ok: "Ok",
            cancel: "Cancel",
        },
        next: "Next",
        previous: "Previous",
        first: "First",
        last: "Last",
        back: "Back"
    },
    transactions: {
        title: "My transactions",
        price: "Amount",
        questionNumber: "Number of question",
        createdAt: "Created at"
    }
}



// WEBPACK FOOTER //
// ./src/translations/en_US.js